export default __webpack_public_path__ + "static/media/IMG_9884.b919952e.jpg";